export const CLEAR_DATA = 'CLEAR_DATA';
export const DATA_FETCHED = 'DATA_FETCHED';
export const UNDO = 'undo';
export const INVALIDATE_ACTION = 'INVALIDATE'
export const ENTITIES_NAMESPACE = 'entities'